import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import Icon from "desktop/components/Icon";
import {colorVariables} from "desktop/theme/variables.js"

import { ReactComponent as PlayIcon } from 'desktop/assets/icons/play.svg';

import {
  ChannelStyled,
  Description,
  Image,
  ImageWrap,
  ChannelLockIcon,
  PlayWrap,
  RecordWrap,
  StyledText,
  StyledTitle,
  TextWrap,
  TitleWrap,
} from "./styles/ChannelStyled";

class Channel extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isMouseEnter: false,
      loadImage: false,
    };
    this.root = React.createRef();
  }

  componentDidMount() {
    const {
      currentChannelAbsoluteId,
      id,
      getCurrentChannelRef,
      parentGenreId,
    } = this.props;
    if (
      _.get(currentChannelAbsoluteId, "id") === id &&
      parentGenreId === _.get(currentChannelAbsoluteId, "genreId")
    ) {
      getCurrentChannelRef(this.root.current);
    }
  }

  UNSAFE_componentWillReceiveProps({
    currentChannelAbsoluteId: nextCurrentChannel,
  }) {
    const {
      currentChannelAbsoluteId: prevCurrentChannel,
      getCurrentChannelRef,
      id,
      parentGenreId,
    } = this.props;
    if (
      nextCurrentChannel &&
      !_.isEqual(nextCurrentChannel, prevCurrentChannel) &&
      id === _.get(nextCurrentChannel, "id") &&
      parentGenreId === _.get(nextCurrentChannel, "genreId")
    ) {
      getCurrentChannelRef(this.root.current);
    }
  }

  onMouseEvent = (event) => {
    this.setState({
      isMouseEnter: event.type === "mouseenter",
    });
  };

  onLoadImage = () => {
    this.setState({
      loadImage: true,
    });
  };

  switchChannel = () => {
    const { id, parentGenreId } = this.props;
    this.props.switchChannel({ id, genreId: parentGenreId }, true);
  };

  render() {
    const {
      img,
      title,
      interactive,
      currentChannelAbsoluteId,
      id,
      locked,
      parentGenreId,
      text,
      lockedHoverText,
    } = this.props;
    const { isMouseEnter, loadImage } = this.state;
    const active =
      _.get(currentChannelAbsoluteId, "id") === id &&
      _.get(currentChannelAbsoluteId, "genreId") === parentGenreId;
    return (
      <ChannelStyled
        onClick={this.switchChannel}
        onMouseEnter={this.onMouseEvent}
        onMouseLeave={this.onMouseEvent}
        id={id}
        active={active}
        ref={this.root}
      >
        <ImageWrap>
          <Image src={img} onLoad={this.onLoadImage} load={loadImage} />
          <PlayWrap>
            <Icon icon={PlayIcon}
                  size={16}
                  viewBox={'0 0 24 24'}
                  color={isMouseEnter ? colorVariables.fire : colorVariables.orange} />
          </PlayWrap>
        </ImageWrap>
        <Description>
          <TitleWrap>
            <StyledTitle size="fs_s" fixedSize color="white">
              {title}
            </StyledTitle>
            {interactive && (
              <RecordWrap>
                <Icon icon={PlayIcon}
                      size={16}
                      viewBox={'0 0 24 24'}
                      color={isMouseEnter ? colorVariables.fire : colorVariables.orange}/>
              </RecordWrap>
            )}
          </TitleWrap>
          <TextWrap>
            <StyledText
              size="fs_xxs"
              font="din_regular"
              fixedSize
              color="gray_smokegray"
            >
              {locked && isMouseEnter ? lockedHoverText : text}
            </StyledText>
          </TextWrap>
        </Description>
        {locked && (
          <ChannelLockIcon size={16} color="rgba(255, 255, 255, 0.4)" />
        )}
      </ChannelStyled>
    );
  }
}

Channel.propTypes = {
  id: PropTypes.number.isRequired,
  img: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  interactive: PropTypes.bool,
  switchChannel: PropTypes.func,
  getCurrentChannelRef: PropTypes.func,
  currentChannelAbsoluteId: PropTypes.object,
  parentGenreId: PropTypes.number,
  locked: PropTypes.bool,
  lockedHoverText: PropTypes.string,
};

Channel.defaultProps = {
  interactive: false,
  text: "",
  switchChannel: Function.prototype,
  getCurrentChannelRef: Function.prototype,
  currentChannelAbsoluteId: {},
  parentGenreId: undefined,
  locked: false,
  lockedHoverText: "В подписке Оптимальная", // TODO: waiting for translation on cms side
};

export default Channel;
